module.exports = __webpack_public_path__ + "static/media/centro_platea_1.ed579606.jpg";